<template>
  <!-- // 国家选择，封装成组件 -->
  <el-select v-model="country" @change="getCty" clearable  placeholder="请选择国家" size="small">
    <el-option
      v-for="(item,index) in options"
      :key="index"
      :label="item.zhname"
      :value="item.zhname"
    ></el-option>
  </el-select>
</template>

<script>
import httpApi from "@/http/api";
export default {
  name: "country",
  props: {
    countrys: { type: String }
  },
  data() {
    return {
      options: [], //国家列表
      country: this.countrys
    };
  },
  methods: {
    init() {
      httpApi.listParams({ params: { type: "sys_country",enable:"1" } }).then(res => {
        this.options = res.data.data;
        // this.country = this.options.find(i => {
        //   return i.zhname == "美国";
        // }).zhname;
      });
    },
    getCty(e) {
      this.$emit("getCty", e);
    },
  },
  created() {
    this.init();
  },
  watch: {
    countrys(newVal) {
      this.country = newVal;
    }
  }
};
</script>

<style lang="less" scoped>
</style>